import { useState } from 'react';
import { RemoveIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseButton = ({
  onClick,
  tabId,
  tooltip,
  disabled
}) => {
  const [use, setUse] = useState('transparent');
  return /*#__PURE__*/_jsx(Flex, {
    onMouseEnter: () => setUse('tertiary-light'),
    onMouseLeave: () => setUse('transparent'),
    children: /*#__PURE__*/_jsx(IconButton, {
      tooltip: tooltip,
      size: "xs",
      use: use,
      disabled: disabled,
      "data-test-id": `close-view-${tabId}`,
      onClick: e => {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        onClick();
      },
      children: /*#__PURE__*/_jsx(RemoveIcon, {
        size: "100",
        color: "icon-primary-default"
      })
    })
  });
};